import * as moment from "moment";

export class MomentHelper {

    private static __defaultWeekStartDay: number = 1;
    private static __currentWeekStartDay: number | null = null;

    public static getDefaultWeekStart(): number {
        return MomentHelper.__defaultWeekStartDay;
    }

    public static getCurrentWeekStartDay(): number {
        return MomentHelper.__currentWeekStartDay || MomentHelper.__defaultWeekStartDay;
    }

    public static initLocale(): void {
        // Todo get general locale
        let weekStartsWith = MomentHelper.getCurrentWeekStartDay();

        MomentHelper.updateWeekStart(weekStartsWith);
    }

    public static updateWeekStart(weekStartsWith: number): void {
        let weekSpec: moment.WeekSpec = {
            dow: weekStartsWith,
            doy: 4
        };

        let localeSpec: moment.LocaleSpecification = {
            week: weekSpec
        };

        moment.updateLocale("et", localeSpec);
    }
}


// WEBPACK FOOTER //
// ./www/js/Helpers/MomentHelper.ts